;(function () {
  function defaultPathFilter() {
    return true;
  }
  function toArray(val) {
    if (!val) return [];
    return Array.isArray(val) ? val : [val];
  }
  function matchPathname(pathname, patterns) {
    if (!patterns || !patterns.length) return true;
    for (var i = 0; i < patterns.length; i++) {
      var p = patterns[i];
      if (!p) continue;
      if (typeof p === 'string' && pathname.indexOf(p) !== -1) return true;
      if (p instanceof RegExp && p.test(pathname)) return true;
      if (typeof p === 'function' && p(pathname) === true) return true;
    }
    return false;
  }
  function hasAccessTokenFromCookie() {
    try {
      var cookieToken = document.cookie
        .split(';')
        .map(function (item) { return item.trim(); })
        .find(function (item) { return item.startsWith('accessToken='); });
      return !!(cookieToken && cookieToken.split('=').slice(1).join('='));
    } catch (err) {
      return false;
    }
  }
  function resolveDefaultTarget(options) {
    var mobileBreakpoint = Number.isFinite(options && options.mobileBreakpoint) ? options.mobileBreakpoint : 734;
    var isMobile = window.innerWidth <= mobileBreakpoint;
    var mobileTarget = (options && options.mobileTarget) || '/pages/mobile-menu';
    var desktopTarget = (options && options.desktopTarget) || '/pages/my-account';
    var target = isMobile ? mobileTarget : desktopTarget;
    return window.withSitePrefix ? window.withSitePrefix(target) : target;
  }
  window.setupAsyncLoginEntryGuard = function setupAsyncLoginEntryGuard(options) {
    if (typeof window === 'undefined') {
      return { check: function () {}, destroy: function () {} };
    }
    var includePaths = toArray(options && options.includePaths);
    var excludePaths = toArray(options && options.excludePaths);
    var pathFilter = (options && options.pathFilter) || defaultPathFilter;
    var runOnLoad = !(options && options.runOnLoad === false);
    var enablePageShow = !(options && options.enablePageShow === false);
    var enableVisibilityChange = !(options && options.enableVisibilityChange === false);
    var delayOnHistory = Number.isFinite(options && options.historyDelay) ? options.historyDelay : 100;
    var delayOnVisibility = Number.isFinite(options && options.visibilityDelay) ? options.visibilityDelay : 100;
    var redirectOnInvalid = !!(options && options.redirectOnInvalid);
    var preserveQueryOnInvalid = !(options && options.preserveQueryOnInvalid === false);
    var onRedirect = (options && options.onRedirect) || function (target) {
      if (typeof target === 'string' && target.length > 0) {
        window.location.href = target;
      }
    };
    var resolveTarget = (options && options.resolveTarget) || function () {
      return resolveDefaultTarget(options || {});
    };
    var onInvalid = (options && options.onInvalid) || function () {
      if (window.authAPI && typeof window.authAPI.clearAuthToken === 'function') {
        try { window.authAPI.clearAuthToken(); } catch (e) {}
      }
      if (redirectOnInvalid) {
        var loginPath = '/pages/login';
        if (preserveQueryOnInvalid) {
          try {
            var current = new URLSearchParams(window.location.search || '');
            var flag = current.get('flag') || '';
            var orderName = current.get('orderName') || current.get('order_name') || '';
            var email = current.get('email') || '';
            var checkoutUrl = current.get('checkout_url') || '';

            var preserved = new URLSearchParams();
            if (flag === 'transfer' && orderName && email) {
              preserved.set('flag', 'transfer');
              preserved.set('orderName', orderName);
              preserved.set('email', email);
            } else if (checkoutUrl) {
              preserved.set('checkout_url', checkoutUrl);
            }

            var qs = preserved.toString();
            if (qs) {
              loginPath = loginPath + '?' + qs;
            }
          } catch (e) {}
        }
        var loginUrl = window.withSitePrefix ? window.withSitePrefix(loginPath) : loginPath;
        window.location.href = loginUrl;
      }
    };
    async function check() {
      try {
        var pathname = window.location && window.location.pathname ? window.location.pathname : '';
        if (!pathFilter(pathname)) return;
        if (excludePaths.length && matchPathname(pathname, excludePaths)) return;
        if (includePaths.length && !matchPathname(pathname, includePaths)) return;
        var hasToken = false;
        if (window.authAPI && typeof window.authAPI.isLoggedIn === 'function') {
          hasToken = !!window.authAPI.isLoggedIn();
        } else {
          hasToken = hasAccessTokenFromCookie();
        }
        if (!hasToken) return;
        var isValid = true;
        if (window.authAPI && typeof window.authAPI.validateToken === 'function') {
          try {
            isValid = await window.authAPI.validateToken();
          } catch (e) {
            isValid = false;
          }
        }
        if (!isValid) {
          if (window.authAPI && typeof window.authAPI.logout === 'function') {
            try { await window.authAPI.logout(); } catch (e) {}
          }
          onInvalid();
          return;
        }
        var target = resolveTarget({ pathname: pathname });
        onRedirect(target);
      } catch (e) {}
    }
    function handleDomReady() {
      document.removeEventListener('DOMContentLoaded', handleDomReady);
      check();
    }
    if (runOnLoad) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleDomReady);
      } else {
        check();
      }
    }
    function handlePageShow(event) {
      var navigationEntries = (typeof performance !== 'undefined' && performance.getEntriesByType)
        ? performance.getEntriesByType('navigation')
        : [];
      var navEntry = (navigationEntries && navigationEntries.length) ? navigationEntries[0] : null;
      var fromHistory = (event && event.persisted === true) || (navEntry && navEntry.type === 'back_forward');
      if (fromHistory) {
        setTimeout(check, delayOnHistory);
      }
    }
    if (enablePageShow) {
      window.addEventListener('pageshow', handlePageShow);
    }
    function handleVisibilityChange() {
      if (!document.hidden) {
        setTimeout(check, delayOnVisibility);
      }
    }
    if (enableVisibilityChange) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    return {
      check: check,
      destroy: function () {
        document.removeEventListener('DOMContentLoaded', handleDomReady);
        if (enablePageShow) {
          window.removeEventListener('pageshow', handlePageShow);
        }
        if (enableVisibilityChange) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
      }
    };
  };
})();

